module.exports = __webpack_public_path__ + "static/media/GoogleSheetsCreateNewSheet-01-01.5abf2de0.svg";